import * as React from 'react';

import * as Sentry from '@sentry/react';

import AdminAssistEpicClient from 'bundles/epic/clients/admin_assist';

/**
 * Hook that determines whether to show the Ask Coursera nav item.
 * Returns false when the org slug is in the EPIC `hide_conversational_assistant` allowlist.
 * Wrapped in useMemo to prevent duplicate EPIC impression events on every render.
 */
export const useShouldShowAskCoursera = (orgSlug: string): boolean =>
  React.useMemo(() => {
    const excludedOrgs = AdminAssistEpicClient.get('hide_conversational_assistant');
    if (!excludedOrgs) {
      return true; // Show by default if config not loaded
    }
    if (!Array.isArray(excludedOrgs)) {
      Sentry.captureException(new Error('[useShouldShowAskCoursera] Invalid hide_conversational_assistant config'), {
        tags: { component: 'useShouldShowAskCoursera' },
        extra: { excludedOrgs },
      });
      return true;
    }
    return !excludedOrgs.includes(orgSlug);
  }, [orgSlug]);
